// extracted by mini-css-extract-plugin
module.exports = {"search":"l_bn","input":"l_bp","search-icon":"l_bq","searchIcon":"l_bq"};